import Vue from 'vue'
import Vuex from 'vuex'
import content from './content'
import playlist from './playlist'
import schedule from './schedule'
import controls from './control'
import user from './user'
import share from './share'
import status from './status'
import tracks from './tracks'
import play from './play'
import website from './website'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    user: user,
    content: content,
    controls: controls,
    playlist: playlist,
    schedule: schedule,
    share: share,
    status: status,
    tracks: tracks,
    play: play,
    website: website,
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js